import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'addEmployee'

export default (data, alternativeCampaignName) => {
  const dataObj = data
  if (alternativeCampaignName) {
    dataObj.alternativeCampaignName = alternativeCampaignName
  }
  return asyncAction(
    name,
    EmployeesService.addEmployee,
    dataObj
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/addEmployee.js